module.exports = __webpack_public_path__ + "ui/img/apple.0aa25920.svg";